var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndoNonactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7717 0.905382L1.00342 10.1779C0.417412 10.5726 0.414344 11.434 0.997526 11.8328L14.7658 21.2486C15.4295 21.7025 16.3303 21.2272 16.3303 20.4232V16.0267C16.3303 15.7505 16.5614 15.5265 16.8375 15.5289C26.92 15.6185 30.2106 18.4118 28.8511 24.3336C28.7431 24.8044 29.4483 25.1495 29.6818 24.7266C38.313 9.09202 22.6465 6.93602 16.8327 6.88021C16.5542 6.87754 16.3303 6.65313 16.3303 6.37467V1.73482C16.3303 0.933997 15.436 0.458041 14.7717 0.905382Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoNonactive);
export default __webpack_public_path__ + "static/media/undo-nonactive.01e7f810e052c0298b91064a9c0f0962.svg";
export { ForwardRef as ReactComponent };